export default __webpack_public_path__ + "static/MediaContentSix-95d0b687cd859a1fef033d5193698dfd.webp";